import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ImageOverlay } from 'pages/onboarding/ImageOverlay';
import { useRedirect } from '../../../../../utils/redirect';
import { RIBOnboardingRoutes } from '../../routes/index';
import { ModalCard } from '../../../../../components/cards/ModalCard';
import { OnboardingGrid } from '../../../OnboardingGrid';
import { Grid } from '../../../../../components/layout/Grid';
import safestTownhouseImage from '../../../../../assets/media/rib/safest-townhouse.jpg';
import { Brikk } from '../../../../../components/Brikk';
import { Text } from '../../../../../components/typography';
import { NextStep } from '../../../../../components/form-elements/buttons/NextStep';

export const SafestTownhouse = () => {
  const { onRedirect } = useRedirect(RIBOnboardingRoutes.SIMPLER_EVERYDAY);

  return (
    <ModalCard>
      <OnboardingGrid>
        <Grid.Column>
          <ImageOverlay
            imageSrc={safestTownhouseImage}
            overlayIntl="onboardingSafestTownhouseTitle"
          />
        </Grid.Column>

        <Grid.Column>
          <Brikk.Heading heading="onboardingSafestTownhouseHeading">
            <Text size={18}>
              <FormattedMessage id="onboardingSafestTownhouseDescription" />
            </Text>
          </Brikk.Heading>
        </Grid.Column>

        <NextStep onClick={() => onRedirect()} />
      </OnboardingGrid>
    </ModalCard>
  );
};
